import React, { ChangeEvent, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { reverseLookup } from 'shared/api/demo'
import { useNavigateTo } from 'infrastructure/routing'

const DemoReverseLookup = () => {
  const [open, setOpen] = useState(false)
  const [demoURL, setDemoURL] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigateTo()

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    setDemoURL('')
    setError('')
  }
  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    setDemoURL(event.target.value)
  }

  const demoLookup = async () => {
    const res = await reverseLookup({ demoURL })

    if (res && res.error) {
      setError(res.error)
    } else {
      navigate(`/demos/${res.result}/show`)
    }
  }

  return (
    <>
      <Button
        variant="text"
        onClick={handleClickOpen}
        style={{ margin: '1' }}
        size="medium"
      >
        Demo Lookup by URL
      </Button>
      <Dialog
        open={open}
        onClose={() => {
          handleClose()
        }}
      >
        <DialogTitle>Perform Demo Lookup from URL</DialogTitle>
        <DialogContent>
          <p>Enter a demo URL or demo create data</p>
          <TextField
            autoFocus
            margin="dense"
            id="demoURL-input"
            label="Demo URL"
            type="text"
            fullWidth
            variant="outlined"
            value={demoURL}
            onChange={handleInput}
            error={!!error}
            helperText={error}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose()
            }}
          >
            Cancel
          </Button>
          <Button onClick={demoLookup} disabled={demoURL == ''}>
            Find
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DemoReverseLookup
